import React, { useState } from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import Select from '@/UIlibrary/Select/Select';
import { useNavigate } from 'react-router-dom';
import { UpdateCompanyForm } from './UpdateCompanyForm';
import { useTranslations } from 'use-intl';

const Information: React.FC = () => {
	const currentLang = location.pathname.split('/')[1];

	const t = useTranslations('Information');
	const [selectedLanguage, setSelectedLanguage] = useState<string>(currentLang);
	const [editing, setEditing] = useState(false);
	const navigate = useNavigate();

	const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const newPathname = location.pathname.replace(`/${currentLang}`, `/${e.target.value}`);
		setSelectedLanguage(e.target.value);
		navigate(newPathname);
	};

	return (
		<div className="py-4 flex flex-col gap-4">
			<div className="flex w-full flex-col md:flex-row items-start md:items-center gap-5">
				<div className="flex flex-col gap-1 grow">
					<p>
						<Typography weight="semibold" size="lg">
							{t('CompanyInformation')}
						</Typography>
					</p>
					<p>
						<Typography color="subtitle" size="sm">
							{t('AdminCompanyInformationDescription')}
						</Typography>
					</p>
				</div>
			</div>
			<hr />
			<div className="w-full md:w-1/3">
				<UpdateCompanyForm
					editing={editing}
					setEditing={setEditing}
					onUpdateInformationSuccess={() => {}}
					onUpdateInformationFailure={() => {}}
				/>
			</div>
			<div className="flex w-full flex-col mt-3">
				<div className="flex flex-col gap-1">
					<p>
						<Typography weight="semibold" size="lg">
							{t('Preferences')}
						</Typography>
					</p>
					<p>
						<Typography color="subtitle" size="sm">
							{t('Personalize')}
						</Typography>
					</p>
				</div>
			</div>
			<hr />
			<div className="w-full md:w-1/3">
				<Select
					dataTestId="language-select"
					label={t('Language')}
					value={selectedLanguage}
					onChange={handleLanguageChange}
					name="language"
					options={[
						{ value: 'en', label: 'English' },
						{ value: 'es', label: 'Español' }
					]}
				/>
			</div>
		</div>
	);
};

export default Information;
